const actions = {
  SET_STATE: "basket/SET_STATE",
};

export default actions;
